import { createSlice } from "@reduxjs/toolkit";
import { fetchInventorySummary } from "./thunk";

interface InventorySummaryState {
  data: any[];
  totalRecords: number;
  low_stock_items_count: number;
  total_stock: number;
  loading: boolean;
  error: string | null;
}

const initialState: InventorySummaryState = {
  data: [],
  totalRecords: 0,
  low_stock_items_count: 0,
  total_stock: 0,
  loading: false,
  error: null,
};

const inventorySummarySlice = createSlice({
  name: "inventorySummary",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventorySummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventorySummary.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.totalRecords = action.payload.totalRecords;
        state.low_stock_items_count = action.payload.low_stock_items_count;
        state.total_stock = action.payload.total_stock;
      })
      .addCase(fetchInventorySummary.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch inventory summary";
      });
  },
});

export default inventorySummarySlice.reducer;

